module.exports = __webpack_public_path__ + "static/img/son9.e23b8120.jpg";